import { render, staticRenderFns } from "./AddGolfService.vue?vue&type=template&id=1569ddef"
import script from "./AddGolfService.js?vue&type=script&lang=js&external"
export * from "./AddGolfService.js?vue&type=script&lang=js&external"
import style0 from "./AddGolfService.vue?vue&type=style&index=0&id=1569ddef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports